import { useLocation } from 'react-router-dom';
import { getLangFromPath, translate } from './i18n.js';

export function useT() {
  const location = useLocation();
  const lang = getLangFromPath(location.pathname);
  const t = (key, vars) => {
    let value = translate(lang, key);
    if (vars && typeof value === 'string') {
      Object.entries(vars).forEach(([k, v]) => {
        value = value.replace(new RegExp(`\\{\\{${k}\\}\\}`, 'g'), v);
      });
    }
    return value;
  };
  return { t, lang };
}
